"use strict";
// Forklifted directly from bitcoinjs-lib @
// https://github.com/bitcoinjs/bip174/blob/25fd6842b76984b169d8f0be2adcb3db322fe98c/src/lib/converter/varint.js#L5 .
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeBitcoinVarUint = void 0;
// Number.MAX_SAFE_INTEGER
const MAX_SAFE_INTEGER = 9007199254740991;
function bitcoinVarUintEncodingLength(number) {
    checkUInt53(number);
    return number < 0xfd
        ? 1
        : number <= 0xffff
            ? 3
            : number <= 0xffffffff
                ? 5
                : // because MAX_SAFE_INTEGER < 0xffffffffffffffff, and 0xffffffffffffffff is
                    // the max number a varuint can safely encode in 9 bytes, we can return 9
                    // without further checks.
                    9;
}
function checkUInt53(n) {
    if (n < 0 || n > MAX_SAFE_INTEGER || n % 1 !== 0)
        throw new RangeError('value out of range');
}
/**
 * Encodes a Bitcoin varuint to represent the passed number. Note that the
 * number is treated as an integer no matter what it actually is, and that
 * the returned buffer is of length 1-9 depending on the number that is
 * being represented.
 */
function encodeBitcoinVarUint(number) {
    checkUInt53(number);
    const buffer = Buffer.allocUnsafe(bitcoinVarUintEncodingLength(number));
    const offset = 0;
    // 8 bit
    if (number < 0xfd) {
        buffer.writeUInt8(number, offset);
        // 16 bit
    }
    else if (number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(number, offset + 1);
        // 32 bit
    }
    else if (number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(number, offset + 1);
        // 64 bit
    }
    else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(number >>> 0, offset + 1);
        buffer.writeUInt32LE((number / 0x100000000) | 0, offset + 5);
    }
    return buffer;
}
exports.encodeBitcoinVarUint = encodeBitcoinVarUint;
